/**
 * Activity API Client
 * Reads the append-only audit feed served at /api/activity.
 */

import { apiClient } from './client';
import type { ActivityFilters, ActivityListResponse } from '@repo/types';

export interface GetActivityParams extends ActivityFilters {
  page?: number;
  limit?: number;
}

/**
 * Fetch activity newest-first, optionally scoped by entity/actor/action.
 */
export async function getActivity(
  params: GetActivityParams = {}
): Promise<ActivityListResponse> {
  const search = new URLSearchParams();
  if (params.page) search.append('page', String(params.page));
  if (params.limit) search.append('limit', String(params.limit));
  if (params.entityType) search.append('entityType', params.entityType);
  if (params.entityId) search.append('entityId', params.entityId);
  if (params.actorId) search.append('actorId', params.actorId);
  if (params.action) search.append('action', params.action);

  const query = search.toString();
  const response = await apiClient.get<ActivityListResponse>(
    `/activity${query ? `?${query}` : ''}`
  );
  return response.data;
}
